var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgApplicationGuide(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 51,
    height: 48,
    viewBox: "0 0 51 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.018,
    y1: 0.015,
    x2: 0.985,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7eaeff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.288,
    stopColor: "#4583ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.771,
    stopColor: "#427bdd",
    stopOpacity: 0.922
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#759fe6"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_632",
    x: 0,
    y: 5.044,
    width: 51,
    height: 42.956,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.153
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.982,
    y1: 0.015,
    x2: 0.015,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "Path_633",
    x: 2.069,
    y: 0,
    width: 46.82,
    height: 47.58,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.153
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5700",
    "data-name": "Group 5700",
    transform: "translate(10.207 7)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -10.21, -7)",
    filter: "url(#Path_632)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_632-2",
    "data-name": "Path 632",
    d: "M3.362,10h.724v9.9c0,.14.162.254.362.254,7.867,0,8.69,2.314,8.7,2.338a.358.358,0,0,0,.354.2h0a.354.354,0,0,0,.351-.2c.012-.037.855-2.337,8.7-2.337.2,0,.362-.114.362-.254V10h.724c.2,0,.362.114.362.254V20.914c0,.14-.162.254-.362.254-9.285,0-9.763,1.481-9.776,1.536a.189.189,0,0,1-.017.067.373.373,0,0,1-.344.182c-.2,0-.362-.107-.362-.247,0-.015-.366-1.537-9.776-1.537-.2,0-.362-.114-.362-.254V10.251C3,10.11,3.162,10,3.362,10Z",
    transform: "translate(12 5.05)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -10.21, -7)",
    filter: "url(#Path_633)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_633-2",
    "data-name": "Path 633",
    d: "M16.06,5.55C15.157,4.357,13.089,3,8.351,3A.331.331,0,0,0,8,3.308V16.57a.331.331,0,0,0,.35.308c7.572,0,7.707,3.546,7.709,3.7ZM15.1,16.3a.339.339,0,0,1-.346.265.406.406,0,0,1-.05,0,.317.317,0,0,1-.3-.349,1.021,1.021,0,0,0-.365-.789c-.472-.464-1.6-1.017-4.289-1.017a.311.311,0,1,1,0-.617c2.393,0,4.02.42,4.836,1.248A1.554,1.554,0,0,1,15.1,16.3Zm0-4.318a.339.339,0,0,1-.346.265.405.405,0,0,1-.05,0,.317.317,0,0,1-.3-.349,1.021,1.021,0,0,0-.365-.789c-.472-.464-1.6-1.017-4.289-1.017a.311.311,0,1,1,0-.617c2.393,0,4.02.42,4.836,1.248A1.554,1.554,0,0,1,15.1,11.987Zm0-4.318a.339.339,0,0,1-.346.265.405.405,0,0,1-.05,0,.317.317,0,0,1-.3-.349,1.021,1.021,0,0,0-.365-.789c-.472-.464-1.6-1.017-4.289-1.017a.311.311,0,1,1,0-.617c2.393,0,4.02.42,4.836,1.248A1.554,1.554,0,0,1,15.1,7.67Zm1.66,12.91c0-.156.137-3.7,7.709-3.7a.331.331,0,0,0,.35-.308V3.308A.331.331,0,0,0,24.47,3c-4.738,0-6.806,1.357-7.709,2.55Zm1.471-5.538c.816-.828,2.443-1.248,4.836-1.248a.311.311,0,1,1,0,.617c-2.69,0-3.817.553-4.289,1.017a1.021,1.021,0,0,0-.365.789.317.317,0,0,1-.3.349.405.405,0,0,1-.05,0,.339.339,0,0,1-.346-.265A1.554,1.554,0,0,1,18.232,15.042Zm0-4.318c.816-.828,2.443-1.248,4.836-1.248a.311.311,0,1,1,0,.617c-2.69,0-3.817.553-4.289,1.017a1.021,1.021,0,0,0-.365.789.317.317,0,0,1-.3.349.406.406,0,0,1-.05,0,.339.339,0,0,1-.346-.265A1.554,1.554,0,0,1,18.232,10.724Zm0-4.318c.816-.828,2.443-1.248,4.836-1.248a.311.311,0,1,1,0,.617c-2.69,0-3.817.553-4.289,1.017a1.021,1.021,0,0,0-.365.789.317.317,0,0,1-.3.349.405.405,0,0,1-.05,0,.339.339,0,0,1-.346-.265A1.554,1.554,0,0,1,18.232,6.407Z",
    transform: "translate(9.07 7)",
    fill: "url(#linear-gradient-2)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplicationGuide);
export default __webpack_public_path__ + "static/media/ApplicationGuide.f346fb9f2b0a38926db6c1d644748ea7.svg";
export { ForwardRef as ReactComponent };